import axios from 'axios';
import appConfig from '../config/config';
import Auth from './auth.service';

/**
 *
 * @param {Boolean} withToken if true inject the token to the header | Default true
 * @param {String} baseUrlPrefix string prefix to define auth url and any custom base urls
 *
 * @returns axsios instance
 */

const instance = axios.create({
  baseURL: window.env.REACT_APP_API_URL,
});

const authInterceptor = config => {
  const token = Auth.getTokenData('accessToken');
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  config.headers['x-local-app'] = appConfig.APP_ID;
  config.headers['Accept-Language'] = appConfig.DEFAULT_LANGUAGE;
  config.headers['Accept'] = 'application/json';

  return config;
};

instance.interceptors.request.use(authInterceptor);

instance.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error?.response?.status === 401 || error?.response?.status === 403) {
      // try to refresh the roken and get new auth data
      Auth.logout();
    } else {
      return Promise.reject(error);
    }
  },
);

export default instance;
